.supportiveMessage {
  margin-bottom: 24px;
}

.modalContentClassName {
  padding-top: 16px;
}
